import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import HeroBanner from '../../components/HeroBanner';
import PropertyTypes from '../../components/PropertyTypes';
import Globe from '../../components/Globe';
import FeaturedHomes from '../../components/FeaturedHomes';
import DiscoverSection from '../../components/DiscoverSection';
import PopularDestinations from '../../components/PopularDestinations';
import AgentSection from '../../components/AgentSection';
import './styles.css';

const popularDestinations = [
  { name: 'New York', image: '/new-york.jpg' },
  { name: 'Los Angeles', image: '/los-angeles.jpg' },
  { name: 'San Jose', image: '/san-jose.jpg' },
  { name: 'Fort Worth', image: '/fort-worth.jpg' },
  { name: 'Kansas City', image: '/kansas-city.jpg' }
];

const Home = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#home-search') {
      // Espera o conteúdo montar e então rola até o formulário
      const timer = setTimeout(() => {
        const el = document.getElementById('home-search');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Tenta focar o input de localização se existir
          const input = el.querySelector('input[type="text"], input');
          if (input) try { input.focus(); } catch(_) {}
        } else {
          // Fallback: rola para o topo
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <div className="home-page">
      <HeroBanner />
      <PropertyTypes />
      <Globe />
      <FeaturedHomes />
      <DiscoverSection />
      <PopularDestinations />
      <AgentSection />

      {/* <section className="featured-properties">
        <h2>Casas em destaque</h2>
        <p>Seleção escolhida a dedo em lugares de qualidade</p>
        <div className="property-grid">
          {featuredProperties.map((property) => (
            <PropertyCard key={property.id} {...property} />
          ))}
        </div>
      </section>

      <section className="vacation-spot">
        <div className="content">
          <h2>Descubra o lugar perfeito para as suas férias</h2>
          <p>Disponível em mais de 50 países ao redor do mundo</p>
          <button className="search-button">Pesquisar agora</button>
        </div>
      </section>

      <section className="popular-destinations">
        <h2>Destinos populares</h2>
        <p>Explore a nossa seleção dos melhores lugares em todo mundo</p>
        <div className="destination-grid">
          {popularDestinations.map((destination) => (
            <Link to={`/destino/${destination.name.toLowerCase()}`} key={destination.name} className="destination-card">
              <img src={destination.image} alt={destination.name} />
              <h3>{destination.name}</h3>
            </Link>
          ))}
        </div>
      </section> */}
    </div>
  );
};

export default Home; 